/* eslint-disable */
// Stream Router and Enhanced Wowza mutations for streaming functionality

export const createStreamRouterInterface = `mutation CreateStreamRouterInterface(
  $streamRouterId: String!
  $interfaceData: StreamRouterInterfaceCreateInput!
) {
  createStreamRouterInterface(
    streamRouterId: $streamRouterId
    interfaceData: $interfaceData
  ) {
    success
    message
    data {
      interfaceId
      name
      description
      streamManagerId
      source {
        url
        type
        max_connections
        latency
        ttl
        passphrase
        stream_id
        max_bw
      }
      destination {
        url
        type
        max_connections
        latency
        ttl
        passphrase
        stream_id
        max_bw
      }
      processors {
        name
        args {
          key
          value
        }
      }
      tags
      whitelist
      autostart
    }
  }
}
`;

export const deleteStreamRouterInterface = `mutation DeleteStreamRouterInterface(
  $streamRouterId: String!
  $interfaceId: String!
) {
  deleteStreamRouterInterface(
    streamRouterId: $streamRouterId
    interfaceId: $interfaceId
  ) {
    success
    message
  }
}
`;

export const createExternalWowzaTarget = `mutation CreateExternalWowzaTarget(
  $serverId: String!
  $applicationId: String!
  $targetConfig: WowzaTargetConfigInput!
) {
  createExternalWowzaTarget(
    serverId: $serverId
    applicationId: $applicationId
    targetConfig: $targetConfig
  ) {
    success
    message
    data {
      targetId
      entryName
      enabled
      sourceStreamName
      streamName
      host
      port
    }
  }
}
`;

export const listWowzaAppTargets = `query ListWowzaAppTargets(
  $serverId: String!
  $applicationId: String!
) {
  listWowzaAppTargets(
    serverId: $serverId
    applicationId: $applicationId
  ) {
    success
    message
    data {
      targets {
        id
        name
        entryName
        enabled
        sourceStreamName
        streamName
        host
        port
        profile
      }
    }
  }
}
`;

export const getWowzaAppTarget = `query GetWowzaAppTarget(
  $serverId: String!
  $applicationId: String!
  $targetId: String!
) {
  getWowzaAppTarget(
    serverId: $serverId
    applicationId: $applicationId
    targetId: $targetId
  ) {
    success
    message
    data {
      id
      name
      entryName
      enabled
      sourceStreamName
      streamName
      host
      port
      profile
      configuration
    }
  }
}
`;

export const listWowzaApplications = `query ListWowzaApplications(
  $serverId: String!
) {
  listWowzaApplications(serverId: $serverId) {
    success
    message
    data {
      applications {
        id
        name
        description
        status
        targets {
          id
          name
        }
      }
    }
  }
}
`;

export const getWowzaApplication = `query GetWowzaApplication(
  $serverId: String!
  $applicationId: String!
) {
  getWowzaApplication(
    serverId: $serverId
    applicationId: $applicationId
  ) {
    success
    message
    data {
      id
      name
      description
      status
      configuration
      targets {
        id
        name
        entryName
        enabled
      }
    }
  }
}
`;

export const listTranscoderTemplates = `query ListTranscoderTemplates(
  $serverId: String!
  $applicationId: String!
) {
  listTranscoderTemplates(
    serverId: $serverId
    applicationId: $applicationId
  ) {
    success
    message
    data {
      templates {
        id
        name
        description
        profile
        configuration
      }
    }
  }
}
`;

// Enhanced equipment query for Wowza servers
export const listEquipmentWowza = `query ListEquipment(
  $filter: ModelEquipmentFilterInput
  $limit: Int
  $nextToken: String
) {
  listEquipment(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      equipmentId
      name
      description
      equipmentType
      status
      configuration
      claimsCanAccess
      claimsCanEdit
    }
    nextToken
  }
}
`;
